import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, MessageCircle } from "lucide-react";
import { BUSINESS, whatsappLink } from "@/lib/business";
import SocialLinks from "@/components/SocialLinks";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-[#27272A] text-white"
    >
      <div className="absolute top-0 inset-x-0 h-1 bg-[#E60000]" />
      <div className="absolute top-1 inset-x-0 h-0.5 bg-[#FFCC00]" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 mb-4">
            <img
              src={BUSINESS.logoUrl}
              alt="The1Autospray logo"
              className="w-20 h-20 object-contain drop-shadow-[0_0_16px_rgba(230,0,0,0.4)]"
            />
            <div className="leading-tight">
              <div className="font-display text-2xl">
                THE<span className="text-[#E60000]">1</span>AUTOSPRAY
              </div>
              <div className="text-[10px] tracking-[0.3em] text-[#FFCC00] font-bold mt-1">
                PAINT • BODY • PRECISION
              </div>
            </div>
          </div>
          <p className="text-[#d4d4d8] max-w-md leading-relaxed">
            Professional automotive paint and body refinishing. Single-stage,
            basecoat/clearcoat, panel repair, and full restoration in the heart
            of Cayman.
          </p>
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-cta"
            className="mt-6 inline-flex items-center gap-2 bg-[#E60000] hover:bg-[#FF1A1A] text-white font-display tracking-widest text-sm px-5 py-3 transition-all hover:-translate-y-0.5"
          >
            <MessageCircle className="w-4 h-4" />
            Chat on WhatsApp
          </a>

          <div className="mt-8">
            <div className="font-display text-xs tracking-[0.3em] text-[#FFCC00] mb-3">
              FOLLOW US
            </div>
            <SocialLinks variant="default" testIdPrefix="footer-social" />
          </div>
        </div>

        <div>
          <div className="font-display text-sm tracking-[0.3em] text-[#FFCC00] mb-4">
            Navigate
          </div>
          <ul className="space-y-2 text-[#d4d4d8]">
            <li>
              <Link
                to="/services"
                className="hover:text-white transition"
                data-testid="footer-link-services"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/pricing"
                className="hover:text-white transition"
                data-testid="footer-link-pricing"
              >
                Pricing
              </Link>
            </li>
            <li>
              <Link
                to="/gallery"
                className="hover:text-white transition"
                data-testid="footer-link-gallery"
              >
                Gallery
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-white transition"
                data-testid="footer-link-contact"
              >
                Contact / Quote
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="font-display text-sm tracking-[0.3em] text-[#FFCC00] mb-4">
            Reach Us
          </div>
          <ul className="space-y-3 text-[#d4d4d8]">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#E60000] mt-1 shrink-0" />
              <span>{BUSINESS.location}</span>
            </li>
            <li className="flex items-start gap-3">
              <MessageCircle className="w-4 h-4 text-[#E60000] mt-1 shrink-0" />
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
                data-testid="footer-whatsapp-text"
              >
                {BUSINESS.whatsapp}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-[#E60000] mt-1 shrink-0" />
              <a
                href={`mailto:${BUSINESS.email}`}
                className="hover:text-white break-all"
                data-testid="footer-email"
              >
                {BUSINESS.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#27272A] py-6">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between text-xs text-[#71717a] font-display tracking-widest">
          <span>© {new Date().getFullYear()} THE1AUTOSPRAY. ALL RIGHTS RESERVED.</span>
          <span>
            BUILT FOR <span className="text-[#FFCC00]">PERFORMANCE</span>. PAINTED
            FOR <span className="text-[#E60000]">PRECISION</span>.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
